import { render, staticRenderFns } from "./request-list-classification-select-container.vue?vue&type=template&id=67f7168e"
import script from "./request-list-classification-select-container.vue?vue&type=script&lang=js"
export * from "./request-list-classification-select-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports